var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("SeaExport.ModifyStatus"),
        visible: _vm.dialogShow,
        width: "480px"
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogShow = $event
        }
      }
    },
    [
      _c("div", [
        _c("div", { attrs: { no: "1" } }, [
          _vm._v(_vm._s(_vm.$t("SeaExport.ModifyManifestStatusTip")))
        ])
      ]),
      _c(
        "div",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { "padding-top": "10px" }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-position": "right", "label-width": "90px" } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "lable-blue",
                  attrs: { label: _vm.$t("SeaExport.SoNo") }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        gap: "10px"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "230px" },
                          attrs: { multiple: "", "collapse-tags": "", no: "2" },
                          on: { change: _vm.handleSoNoChange },
                          model: {
                            value: _vm.selectedSoNos,
                            callback: function($$v) {
                              _vm.selectedSoNos = $$v
                            },
                            expression: "selectedSoNos"
                          }
                        },
                        _vm._l(_vm.soNos, function(item) {
                          return _c("el-option", {
                            key: item.soNo,
                            attrs: { label: item.soNo, value: item.soNo }
                          })
                        }),
                        1
                      ),
                      _c(
                        "el-checkbox",
                        {
                          on: { change: _vm.handleAllSoNosChange },
                          model: {
                            value: _vm.allSoNos,
                            callback: function($$v) {
                              _vm.allSoNos = $$v
                            },
                            expression: "allSoNos"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.AllSoNos")))]
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lable-blue",
                  staticStyle: { width: "320px" },
                  attrs: { label: _vm.$t("SeaExport.ReceiptStatus") }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { no: "3" },
                      model: {
                        value: _vm.status,
                        callback: function($$v) {
                          _vm.status = $$v
                        },
                        expression: "status"
                      }
                    },
                    _vm._l(_vm.allowModifyTypes, function(item) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: {
                          label: _vm.isZh ? item.chineseName : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.saveEventHandler } },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.dialogShow = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Return")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }